import React from "react";

import { IconType } from "../../type/icon_type";

interface IconXProps extends IconType {
  onClick?: () => void;
}

const IconX = ({ color, width, height, style, onClick }: IconXProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...style, cursor: "pointer" }}
      onClick={onClick}
    >
      <path
        d="M17 7L7 17M7 7L17 17"
        stroke={color || "#73787E"}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconX;
